import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Chip, Text } from '@frontend/design-system';

type Props = {
  taskCount: number;
  onClick?: () => void;
};

const TaskChip = ({ taskCount, onClick }: Props) => {
  const { t } = useTranslation('calls');

  if (taskCount === 0) {
    return '-';
  }

  return (
    <Chip as='button' rightElement={<Icon name='caret-right-tiny' />} css={styles.chip} onClick={onClick}>
      <Text size='small' color='white' weight='bold'>
        {t('{{ count }} Task', { count: taskCount })}
      </Text>
    </Chip>
  );
};

export default TaskChip;

const styles = {
  chip: css`
    background-color: ${theme.colors.tangerine40};
    border: 1px solid ${theme.colors.tangerine60};
    color: ${theme.colors.white};
    gap: ${theme.spacing(0.5)};
    cursor: pointer;
    &:hover {
      background-color: ${theme.colors.tangerine50};
    }

    @container (max-width: ${breakpoints.small.max}px) {
      font-size: ${theme.font.size.small};
      padding: ${theme.spacing(0.25, 0.5)};
      height: ${theme.spacing(2)};
      > svg {
        height: ${theme.spacing(1)};
      }
      &:focus {
        outline: none;
      }
    }
  `,
};
